<template>
  <div>
    <Modal
      class="addSourceServeModel"
      width="500"
      v-model="currentServeStatus"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
    <!-- 上面提示文字 -->
    <div class="tip-header">
      <span>服务信息表维护</span>
      <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
    </div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem style="margin-right: 18px;width: 100%;" label="服务名称">
        <Input class="ys_input_border_bottom" v-model="formValidate.srv_name" placeholder="请输入服务名称" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="目标主机名称">
        <Input class="ys_input_border_bottom" v-model="formValidate.remote_uname" placeholder="请输入目标主机名称" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="目标主机服务类型">
        <Input class="ys_input_border_bottom" v-model="formValidate.soc_ip" placeholder="请输入目标主机服务类型" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="服务类型">
        <Input class="ys_input_border_bottom" v-model="formValidate.srv_fun_type_name" placeholder="请输入服务类型" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="服务路径">
        <Input class="ys_input_border_bottom" v-model="formValidate.user_root_path" placeholder="请输入服务路径" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="服务类名">
        <Input class="ys_input_border_bottom" v-model="formValidate.srv_class_name" placeholder="请输入服务类名" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" label="本地/远程执行标志">
        <Input class="ys_input_border_bottom" v-model="formValidate.sallow_flag_name" placeholder="请输入本地/远程执行标志" disabled />
      </FormItem>
      <FormItem style="width: 100%;" label="服务方法名	">
        <Input class="ys_input_border_bottom" v-model="formValidate.srv_method_name" placeholder="请输入服务方法名" disabled/>
      </FormItem>
      <FormItem style="width: 100%;" prop="srv_bk_desc" label="服务描述">
        <Input type="textarea" v-model="formValidate.srv_bk_desc" placeholder="请输入服务描述" :autosize="{minRows: 5,maxRows: 8}" :disabled="codeValue !== 1"/>
      </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="handleReset('formValidate')" style="width: 100px; margin-right: 20px">{{ codeValue === 1 ? '取消' : '关闭' }}</Button>
      <Button class="ys-confirm" type="primary" @click="handleSubmit('formValidate')" style="width: 100px;" v-if="codeValue === 1">确认</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props: {
    codeValue: {
      type: Number,
      defalut: 1
    },
    currentServeStatus:{
      type: Boolean,
      defalut: false
    },
    delateItem: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formValidate: {
        srv_name: '', // 服务名称
        remote_uname: '', // 目标主机名称
        srv_bk_desc: '', // 服务描述
        soc_ip: '', // 目标主机服务类型
        srv_fun_type_name: '', // 服务类型
        user_root_path: '', // 服务路径
        srv_class_name: '', // 服务类名
        sallow_flag_name: '', // 远程执行标志
        srv_method_name: '', // 服务方法名
      },
      ruleValidate: {
        srv_bk_desc: [
          { required: true, message: '请输入服务描述', trigger: 'blur' }
        ],
      },
      sup_srvg_code: '',
      srv_name: '',
    }
  },
  methods: {
    ...mapActions([
      'saPageSrvByFunTypeActionQrySrv',
      'PageSrvByFunTypeActionUpdateSrv'
    ]),
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.updateResources();
        } else {
          this.$Message.error('请完善信息！');
        }
      })
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      this.$emit('on-serve-click');
    },
    // 编辑保存
    async updateResources() {
      try {
        let ev = {
          srv_name: this.srv_name,
          sup_srvg_code: this.sup_srvg_code,
          srv_bk_desc: this.formValidate.srv_bk_desc
        }
        const data = await this.PageSrvByFunTypeActionUpdateSrv(ev);
        if (data.request_state) {
          this.$Message.success('编辑成功！');
          this.$emit('on-serve-click');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑回显
    async saPageSrvByFunTypeActionQrySrvs() {
      try {
        const data = await this.saPageSrvByFunTypeActionQrySrv({srv_name: this.delateItem.srv_name});
        if (data.request_state) {
          this.formValidate = data.srv_info;
          this.sup_srvg_code = data.srv_info.sup_srvg_code;
          this.srv_name = data.srv_info.srv_name;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    // 展示详情
    this.saPageSrvByFunTypeActionQrySrvs();
  },
}
</script>
<style lang="less" scoped>
.addSourceServeModel {
  .tip-header {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 24px;
    span:nth-of-type(1) {
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(179,195,226,1);
    }
    span:nth-of-type(2) {
      font-size: 28px;
    }
    span:nth-of-type(2):hover {
      cursor: pointer;
    }
  }
  .btn-box {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-top: 40px;
  }
  .protocolParameters {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
